module.exports = __webpack_public_path__ + "static/img/risk.eabf98f7.svg";